import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
// import AppLngSwitcher from '@crema/core/AppLngSwitcher';
import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
import { toggleNavCollapsed } from 'redux/actions';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch } from 'react-redux';
import AppNotifications from '../../../AppNotifications';
import { alpha } from '@mui/material/styles';
import AppLogo from '../../components/AppLogo';
import UserInfo from '../../components/UserInfo';
import HeaderNavWrapper from './HeaderNavWrapper';
import HorizontalNav from '../../components/HorizontalNav';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import AppNotifications2 from '../../../AppNotifications2';

const AppHeader = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { sidebarBgColor, sidebarTextColor } = useSidebarContext();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();

  return (
    <>
      <AppBar
        position='relative'
        color='inherit'
        sx={{
          boxShadow: 'none',
          width: '100%',
        }}
        className='app-bar'
      >
        <Toolbar
          sx={{
            boxSizing: 'border-box',
            minHeight: { xs: 56, sm: 70 },
            px: { xs: 0 },
            borderBottom: (theme) =>
              `solid 1px ${alpha(theme.palette.common.black, 0.15)}`,
            // backgroundColor: sidebarBgColor,
            // color: sidebarTextColor,
            backgroundColor: 'white',
            color: 'rgba(0, 0, 0, 0.60)'
          }}
        >
          <Box
            sx={{
              width: '100%',
              //   maxWidth: { lg: 1140, xl: 1420 },
              mx: 'auto',
              px: 5,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Hidden lgUp>
              <IconButton
                sx={{
                  marginRight: (theme) => theme.spacing(2),
                  // color: sidebarTextColor,
                  color: 'rgba(0, 0, 0, 0.60)'
                }}
                edge='start'
                className='menu-btn'
                color='inherit'
                aria-label='open drawer'
                onClick={() => dispatch(toggleNavCollapsed())}
                size='large'
              >
                <MenuIcon
                  sx={{
                    width: 35,
                    height: 35,
                  }}
                />
              </IconButton>
            </Hidden>

            <Box
              sx={{
                '& .app-logo': {
                  pl: 0,
                },
                '& .logo-text': {
                  display: { xs: 'none', sm: 'block' },
                },
              }}
            >
              <AppLogo />
            </Box>

            <Box
              sx={{
                flexGrow: 1,
              }}
            />
            {/* <Box
              sx={{
                minHeight: 40,
                position: 'relative',
                display: { xs: 'none', sm: 'block' },
                '& .searchRoot': {
                  position: { xs: 'absolute', sm: 'relative' },
                  right: { xs: 0, sm: 'auto' },
                  top: { xs: 0, sm: 'auto' },
                },
              }}
            >
              <AppSearchBar
                iconPosition='right'
                placeholder='Search…'
                sx={{
                  '&.MuiInputBase-root .MuiInputBase-input': {
                    paddingLeft: 4,
                    backgroundColor: grey[100],
                    width: '200px'
                  },
                  '&.MuiInputBase-root .MuiInputBase-input:focus': {
                    width: '240px'
                  }
                }} />
            </Box> */}
            {/* <Box sx={{ml: 4}}>
              <AppLngSwitcher iconOnly={true} tooltipPosition='bottom' />
            </Box> */}

            <Box
              sx={{
                ml: 4,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Hidden smDown>
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: -2,
                    marginRight: -2,
                  }}
                >
                  <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    {/* <AppNotifications /> */}
                    {/* komponen Notifikasi Portal */}
                    <AppNotifications2 /> 
                  </Box>
                  {/* <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    <AppMessages />
                  </Box> */}
                </Box>

                <Box
                  sx={{
                    ml: { sm: 4 },
                    mr: { xs: 4, sm: 0 },
                    minWidth: { md: 220 },
                    '& .user-info-view': {
                      p: 0,
                    },
                    '& .user-info': {
                      display: { xs: 'none', md: 'block' },
                      color: 'inherit',
                    },
                  }}
                >
                  <UserInfo />
                </Box>
              </Hidden>

              <Hidden smUp>
                <Box
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: -2,
                    marginRight: -2,
                  }}
                >
                  <Box
                    sx={{
                      px: 1.85,
                    }}
                  >
                    <AppNotifications2 />
                  </Box>
                </Box>
              </Hidden>
            </Box>
          </Box>
        </Toolbar>
        <Hidden lgDown>
          <HeaderNavWrapper>
            <Box
              sx={{
                width: '100%',
                // maxWidth: { lg: 1140, xl: 1436 },
                mx: 'auto',
                px: 5,
              }}
            >
              <HorizontalNav />
            </Box>
          </HeaderNavWrapper>
        </Hidden>
      </AppBar>
    </>
  );
};
export default AppHeader;
